import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, defer } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MmSpinningService {
    count$: BehaviorSubject<number> = new BehaviorSubject<number>(0)
    constructor() {
    }

    startWith<T>(observable: Observable<T>) {
        return defer(() => {
            var count = this.count$.value;
            count++
            this.count$.next(count);
            return observable;
        }).pipe(
            finalize(() => {
                var count = this.count$.value;
                count--;
                this.count$.next(count);
            })
        )
    }

}